export default "__VITE_ASSET__CfIttL7V__"